// extracted by mini-css-extract-plugin
export default {"Footer":"view-changes-button-module__Footer--_SGsD"};